import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function DevolucionesYResponsabilidad() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>XIII. DEVOLUCIONES Y SALDOS</h4>
          <br></br>
          <p>
            El Usuario/ Cliente Corporativo. disponen de un plazo máximo de dos (2) meses, contados a partir de la fecha en que se solicite la baja del servicio o se genere un saldo pendiente, para optar entre:
          </p>
          <ol style={{ listStyleType: 'lower-alpha', paddingLeft: '20px' }}>
            <li>
              <p>Solicitar el reintegro del saldo existente, o</p>
            </li>
            <li>
              <p>Redimir un bono equivalente al mismo.</p>
            </li>
          </ol>
          <p>
            Si transcurrido dicho plazo el Usuario/ Cliente Corporativo. no ha solicitado el reintegro ni ha redimido el bono, la empresa estará facultada para disponer del dinero, conforme a sus políticas internas y la normatividad aplicable. Esta condición será informada al Usuario/ Cliente Corporativo en el momento de la solicitud de baja. Adicionalmente, durante el plazo establecido, la empresa enviará recordatorios periódicos por correo electrónico para garantizar que el Usuario/ Cliente Corporativo. esté al tanto de la necesidad de escoger entre el reintegro del saldo o la redención del bono.
          </p>
          <br></br>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>XIV. LIMITACIONES DE RESPONSABILIDAD DE PARKING</h4>
          <br></br>
          <p>
            Frente a las Plataformas, Parking no garantiza la disponibilidad ni la continuidad de los Servicios, por lo tanto, no se responsabiliza por interrupciones o fallas técnicas de las Plataformas que puedan causar daños o perjuicios al Usuario/ Cliente Corporativo.
          </p>
          <p>
            En relación con la prestación del servicio de parqueadero, Parking informa que no puede garantizar un servicio ininterrumpido ni libre de errores, ya que estos pueden surgir por factores ajenos o atribuibles al Usuario/ Cliente Corporativo. No obstante, Parking se compromete a resolver cualquier inconveniente dentro de sus posibilidades y a indemnizar al Usuario/ Cliente Corporativo. conforme a las normas de protección al consumidor, siempre y cuando se compruebe que Parking tiene responsabilidad directa. Esta indemnización aplicará únicamente si el Usuario estaba utilizando activamente el Servicio y el vehículo se encontraba dentro del establecimiento en el momento de los daños o inconvenientes.
          </p>
          <p>
            Fuera del horario de prestación del servicio, no se entenderá que exista un contrato de depósito entre el usuario y Parking. En consecuencia, Parking no asumirá responsabilidad alguna por el vehículo. Durante estos periodos no operativos, la custodia y vigilancia del vehículo recaerán exclusivamente en el usuario, quien asume los riesgos derivados de su permanencia en el establecimiento fuera del horario autorizado.
          </p>
          <p>
            En el caso de los usuarios con mensualidad, cuyo uso también está sujeto al horario de funcionamiento del parqueadero, si al momento del cierre el vehículo permanece dentro del establecimiento, el operador definirá el procedimiento mediante el cual se informará al usuario el estado del vehículo. Esta medida tiene como propósito dejar constancia de las condiciones en que se encuentra el vehículo al cierre de la operación, pues después del horario de prestación del servicio, el usuario asume la responsabilidad del vehículo.
          </p>
        </Col>
      </Row>
    </Container>
  );
}